import ds from './DataSourceService'

const baseUrl = '/buildings'

const getBuildingById = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id)
}

const getPoisForBuilding = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/pois')
}

const getApartmentsForBuilding = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/apartments')
}

const getApartmentTypesForBuilding = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/apartment-types')
}

const getApartmentOrientationsForBuilding = id => {
  return ds.apiClientThinkHome.get(
    baseUrl + '/' + id + '/apartment-orientations'
  )
}

const addBuilding = building => {
  return ds.apiClientThinkHome.post(baseUrl, building)
}

const updateBuilding = building => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + building.id, building)
}

const deleteBuilding = buildingId => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + buildingId)
}
export default {
  getBuildingById,
  getPoisForBuilding,
  getApartmentsForBuilding,
  getApartmentTypesForBuilding,
  getApartmentOrientationsForBuilding,
  addBuilding,
  updateBuilding,
  deleteBuilding
}
